<section class="inventory-section" aria-labelledby="distributor-inventory-title">
  <header class="inventory-section__header">
    <div>
      <h3 id="distributor-inventory-title" class="inventory-section__title">
        {{ app.text.manufacturer.distributorInventory }}
      </h3>
      <p class="inventory-section__description">
        {{ app.text.manufacturer.inventoryAvailabilityByDistributor }}
      </p>
    </div>
    <div class="inventory-section__count" aria-live="polite">
      <span class="inventory-section__count-value">
        {{ app.manufacturerUtils.currentInvDocs.length }}
      </span>
      <span>results</span>
    </div>
  </header>

  <div class="tableFixHead inventory-table-wrapper">
    <table class="table inventory-table">
      <caption class="visually-hidden">
        Distributor inventory results
      </caption>
      <thead>
        <tr class="inventory-table__heading-row">
          @for (column of columns; track column) {
            <th
            [ngClass]="{
              'inventory-table__distributor-column':
                column === 'manufacturer.distributor',
              'inventory-table__quantity-column':
                column === 'manufacturer.quantity',
              'inventory-table__type-column':
                column === 'manufacturer.distributorType',
              'inventory-table__updated-column':
                column === 'manufacturer.lastUpdated'
            }"
              scope="col"
              >
              <button
                type="button"
                class="inventory-table__sort-button"
                [attr.aria-label]="'Sort by ' + app.field.getLabel(column)"
              [attr.aria-sort]="
                column === app.table.sortField
                  ? app.table.sortDirection === 1
                    ? 'ascending'
                    : 'descending'
                  : 'none'
              "
              (click)="
                app.table.toggleSortDirection(column);
                app.table.sort(app.manufacturerUtils.currentInvDocs)
              "
                >
                <span>{{ app.field.getLabel(column) }}</span>
                @if (column === app.table.sortField) {
                  <i
                [ngClass]="{
                  'fa-chevron-up': app.table.sortDirection === 1,
                  'fa-chevron-down': app.table.sortDirection === -1
                }"
                    class="fa inventory-table__sort-icon"
                    aria-hidden="true"
                  ></i>
                }
                @if (column !== app.table.sortField) {
                  <i
                    class="fa fa-sort inventory-table__sort-icon inventory-table__sort-icon--inactive"
                    aria-hidden="true"
                  ></i>
                }
              </button>
            </th>
          }
        </tr>
        <tr class="inventory-table__filter-row">
          @for (column of columns; track column) {
            <th scope="col">
              @if (app.filterTable.getFilterTableColumns(column)) {
                <div>
                  <app-filter-table
                    [column]="app.mail.getColumnShort(column)"
                    [columns]="cleanColumns"
                    [docType]="'manufacturer'"
                    [cleanDocs]="allInventoryDocs"
                    [selectedFilters]="selectedFilters"
                (resultedDocs)="
                  app.filterTable.getFilterResults($event, 'manufacturer')
                "
                    [resetComponent]="resetFilterInputsObservable"
                    >
                  </app-filter-table>
                </div>
              }
            </th>
          }
        </tr>
      </thead>
      <tbody>
        @for (doc of app.manufacturerUtils.currentInvDocs; track doc) {
          <tr
            class="inventory-table__data-row"
            >
            @for (column of cleanColumns; track column) {
              <td
            [ngClass]="{
              'inventory-table__distributor-cell': column === 'distributor',
              'inventory-table__quantity-cell': column === 'quantity',
              'inventory-table__type-cell': column === 'distributorType',
              'inventory-table__updated-cell': column === 'lastUpdated'
            }"
                >
                @if (column === 'quantity') {
                  <div class="inventory-table__quantity-content">
                    <span class="inventory-table__quantity-value">
                      {{ doc[column] }}
                    </span>
                    <span class="inventory-table__quantity-bar" aria-hidden="true">
                      <span
                        class="inventory-table__quantity-bar-fill"
                        [style.width.%]="doc[column] / 60000 * 100"
                      ></span>
                    </span>
                  </div>
                } @else {
                  <div>
                    @switch (app.table.getColumnTypeDisplay(column)) {
                      @case ('normal') {
                        <div>
                          {{ doc[column] }}
                        </div>
                      }
                      @case ('link') {
                        <div>
                          @if (doc['buyNowLink']) {
                            <a
                              [href]="doc['buyNowLink']"
                              target="_blank"
                              rel="noopener noreferrer"
                              class="inventory-table__distributor-link"
                              >
                              <span>{{ doc[column] }}</span>
                              <i
                                class="fa fa-arrow-up-right-from-square"
                                aria-hidden="true"
                              ></i>
                            </a>
                          }
                          @if (!doc['buyNowLink']) {
                            <span>{{ doc[column] }}</span>
                          }
                        </div>
                      }
                    }
                  </div>
                }
              </td>
            }
          </tr>
        }
        @if (loading) {
          <tr class="inventory-table__message-row">
            <td colspan="99">{{ app.text.core.loading }}</td>
          </tr>
        }
        @if (
          !loading && app.manufacturerUtils.currentInvDocs.length === 0
          ) {
          <tr
            class="inventory-table__message-row"
            >
            <td colspan="99">{{ app.text.app.noResults }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  <footer class="inventory-section__footer">
    <span>
      Showing {{ app.manufacturerUtils.currentInvDocs.length }} distributor
      results
    </span>
    <span class="inventory-section__footer-hint">
      Use the column filters to narrow the results
    </span>
  </footer>
</section>
